import { Overlay as BaseOverlay } from '@platform-ui/popup-latest';
import { TuiIconTdsMediumPragmaticCross } from '@tui-react/proprietary-icons';
import React from 'react';
import { inIframe } from '../../utils/location';
import styles from './Overlay.module.css';

interface OverlayProps {
  opened: boolean;
  onClose: VoidFunction;
  children: React.ReactNode;
}

export const Overlay: React.FC<OverlayProps> = ({ opened, onClose, children }) => {
  const isIframe = inIframe();

  return (
    <BaseOverlay
      opened={opened}
      onClose={onClose}
      height="100vh"
      {...(isIframe && { vars: () => ({ '--t-overlay-background': 'var(--tui-background-accent-opposite)' }) })}
    >
      <div className={styles.container}>
        {children}

        <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Закрыть изображение">
          <TuiIconTdsMediumPragmaticCross iconSize="var(--icon-xs)" />
        </button>
      </div>
    </BaseOverlay>
  );
};
